module.exports = __webpack_public_path__ + "static/media/spring-min.df2e3cab.jpg";